import React from 'react';

const CheckboxInput = ({
  label,
  name,
  id,
  checked,
  onChange,
  disabled = false,
  className = '',
}) => {
  const handleInternalChange = (e) => {
    onChange({
      target: {
        name: e.target.name,
        value: e.target.checked ? 1 : 0,
        type: 'checkbox',
        checked: e.target.checked,
      },
    });
  };

  return (
    <div className={`mb-4 flex items-center ${className}`}>
      <label htmlFor={id} className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            type="checkbox"
            id={id}
            name={name}
            className="sr-only"
            checked={checked === 1}
            onChange={handleInternalChange}
            disabled={disabled}
          />
          <div
            className={`block w-10 h-6 rounded-full ${
              checked === 1 ? 'bg-blue-600' : 'bg-gray-600'
            } transition-colors duration-200 ease-in-out`}
          ></div>
          <div
            className={`dot absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 ease-in-out ${
              checked === 1 ? 'translate-x-full' : 'translate-x-0'
            }`}
          ></div>
        </div>
        <div className="ml-3 text-text-gray text-sm font-bold">{label}</div>
      </label>
    </div>
  );
};

export default CheckboxInput;